export const BI_mock_data = [
    {title: 'Actual vs Target-Orders (BI) by Customer Number'},
    {title: 'Actual vs Target-Sales (BI) by Customer Number'},
    {title: 'Comm. Sales Inv. Analysis (BI) by Customer Number'},
    {title: 'Commission Order Analysis (BI) by Customer Number'},
    {title: 'Invoice Analysis (BI) by Customer Number'},
    {title: 'Order Analysis (BI) by Customer Number'},
    {title: 'Project Profitability (BI) by Customer Number'},
    {title: 'Project Report Analysis (BI) by Customer Number'},
    {title: 'Sales Forecast Analysis (BI) by Customer Number'},
    {title: 'Sales Opportunity Analysis (BI) by Customer Number'},
    {title: 'Serv Call Status Analysis (BI) by Customer Number'},
    {title: 'Service Call Analysis (BI) by Customer Number'},
    {title: 'Warehouse Task Analysis (BI) by Customer Number'}
];
